<template>
    <div>
        <el-card class="box-card">
            <div slot="header" class="card-header">
                <span>专业统计</span>
                <div class="card-tools">
                    <ul class="nav">
                        <li class="nav-item" style="margin-right: 5px;">
                            <el-select v-model="searchForm.BatchId" placeholder="请选择" class="width_100Pie" @change="onChangeBatch">
                                <el-option v-for="item in optBatch" :key="item.batchId" :label="item.name" :value="item.batchId">
                                </el-option>
                            </el-select>
                        </li>
                        <li class="nav-item">
                            <el-button style="background-color:#17a2b8	;color: white;" icon="el-icon-download" @click="onOpenExport()" v-if="isPower.statistics_major_export">导出</el-button>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="card-body p-0" v-if="itemData!=null">
                <el-table stripe :data="itemData" class="elTableData">
                    <el-table-column type="index" label="序号" width="80"></el-table-column>
                    <el-table-column prop="name" label="专业名称" min-width="200" :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column prop="first" :label="'第'+ index +'志愿填报人数'" min-width="120" :show-overflow-tooltip="true" v-for="index in maxChoice" :key="index">
                        <template slot-scope="scope">
                            <span>
                                {{ scope.row.number[index-1] }}
                            </span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="card-body " v-else>
                <el-empty :image-size="200" description="暂无数据" name="3"></el-empty>
            </div>
        </el-card>
    </div>
</template>

<script>
export default {
    components: {
    },
    data() {
        return {
            fullscreenLoading: false,
            dialogVisible: false,
            random: 0,
            itemData: null,
            
            searchForm: {
                BatchId: null
            },
            searchFormReset: null,
            optBatch: [],
            maxChoice: 0,
            isPower: {
                //增删改查 权限管理
                statistics_major_export: false,
            },
        }
    },
    created() {
        let that = this;
        
        isPower(that, "statistics_major_export", "statistics_major_export");

        ajaxGet(that, "/api/admin/enrollbatch", null, function (resBatch) {
            if (resBatch && resBatch.length > 0) {
                that.optBatch = resBatch;
                that.searchForm.BatchId = that.optBatch[0].batchId;
                that.maxChoice = that.optBatch[0].maxChoice;
            }

            that.searchFormReset = JSON.parse(JSON.stringify(that.searchForm));

            onGetDataPage(that);
        })
    },
    watch: {
      '$route': function(to) {
        let that = this;
        onGetDataPage(that);
      },
    },
    methods: {
        onChangeBatch() {
            let that = this;
            that.maxChoice = 0;
            let maxChoice = that.optBatch.find(x => x.batchId == that.searchForm.BatchId).maxChoice;
            if (!regNull(maxChoice)) {
                that.maxChoice = maxChoice;
            }
            onGetDataPage(that);
        },
        onResetSearch() {
            let that = this;
            that.searchForm = JSON.parse(JSON.stringify(that.searchFormReset));
            onGetDataPage(that)
        },
        onOpenExport() {
            let that = this;
            let fileName = '专业统计' + that.$UploadTime() + '.xls';
            let data = {
                BatchId: that.searchForm.BatchId,
            };
            that.fullscreenLoading = true;
            ajaxExport(that, '/api/admin/enrollmajor/exportmajorstatistics', data, fileName, function (res) {
                that.fullscreenLoading = false;
            })
        },
        onSearch()// 搜索
        {
            let that = this
            onGetDataPage(that);
        },
    },
}
// 分页获取数据
function onGetDataPage(that) {
    let data = {
        BatchId: that.searchForm.BatchId,
    };
    that.fullscreenLoading = true;
    that.itemData = [];
    ajaxGet(that, "/api/admin/enrollmajor/majorstatistics", data, function (r) {
        that.fullscreenLoading = false;
        if (r && r.length > 0) {
            that.itemData = r;
        }
        
    });
}
</script>

<style lang="less" scoped>
/deep/ .el-table .warning-row {
    text-align: center;
}
.selTitleBox {

font-size: 14px;
}

.selTitleBox .spTitle {
color: #303133;
}

.selBodyBox {
padding-top: 5px;
}
</style>